import { PriceOverride } from "../../../../services/instruments";

export const FORM_ID = "price-override-form";

/**
 * The ownership boundary, stated once. The desktop panel and the mobile form render the same
 * paragraph from here rather than each carrying its own wording: this is the only place the
 * import horizon is explained at length (the valuation note beside a blocked value is a single
 * clipped line), so the two surfaces saying different things would be a real difference, not a
 * cosmetic one.
 */
export const PRICE_OVERRIDE_POLICY =
  "These are your own prices. Only you can see them, they never become market quotes for anyone " +
  "else, and they only affect your valuations. PMA imports market history from 1 January 2020. " +
  "Before that date, a price you enter yourself is the only way to value this position.";

/** The date field's expected shape, shown on both surfaces so neither reads as free text. */
export const DATE_PLACEHOLDER = "YYYY/MM/DD";

/**
 * One saved row as text: the date, what was entered, and what it converted to. Shared so the two
 * lists cannot describe the same override differently.
 */
export const formatOverride = (
  override: PriceOverride,
  nativeCurrency: string,
): string =>
  `${override.date} · ${override.priceNative} ${nativeCurrency} · €${override.priceEur}`;
